(function(window) {
    'use strict'

    const aliases = {
        contactPhone: 'contacts.phone',
        'contact-phone': 'contacts.phone',
        contactEmail: 'contacts.email',
        'contact-mail': 'contacts.email',
        certificateClickToPay: 'certificates.clickToPay',
        certificate_click2pay: 'certificates.clickToPay',
        popupBannerView: 'popupBanner.view',
        'popup-banner__view': 'popupBanner.view',
        popupBannerClick: 'popupBanner.click',
        'popup-banner__click': 'popupBanner.click'
    }

    window.SEND_METRIC = function(eventName, params) {
        if (!window.RT || !window.RT.analytics) {
            return Promise.resolve(false)
        }

        const ticket = window.RT.analytics.track(
            aliases[eventName] || eventName,
            {params: params || {}}
        )

        return Promise.race([
            ticket.persisted,
            new Promise(function(resolve) {
                setTimeout(function() {
                    resolve(false)
                }, window.RTAnalyticsInternal.config.navigationWaitMs)
            })
        ])
    }
})(window)
